export class CourseSurveySubmission {
  public id: number;
  public answer?: string;
  public answerId?: number;
}
